module.exports = __webpack_public_path__ + "img/pc_p3_y3.afec48ce.png";